<!--
 * @Author: Merlin
 * @Date: 2024-09-26 17:59:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-10-17 16:32:35
 * @Description: 
-->
<template>
    <span class="contract-state cursor-default" 
        :style="{color: sColor}"
    >
        <IconSvgUse
            :size="props.state === oWavesContractStatus.active ? '15px' : '22px'"
            :use="sIcon" 
        />
        <template v-if="!onlyIcon">
            &nbsp;{{ $t(`waves.${props.state}`) }}
        </template>
    </span>
</template>

<script setup lang="ts">
import {
    oWavesContractStatus,
} from '@/socket/game/dto/waves.dto';
import {
    oColorInfo, 
} from '../ts/wavesData';  

const props = defineProps({
    state: {
        type: String as PropType<oWavesContractStatus>,
        required: true,
    },
    onlyIcon: {
        type: Boolean,
    },
});

// ↓ 颜色 
const sColor = computed(() => {
    const showGreen = [
        oWavesContractStatus.profit,
        oWavesContractStatus.cashed, // 损失钱了也显示为绿色 
    ];;
    const showGray = [
        oWavesContractStatus.loss,
        oWavesContractStatus.busted,
    ];
    // ↓ 开始判断 
    if (showGreen.includes(props.state)){
        return oColorInfo.green.color;
    }else if (showGray.includes(props.state)){
        return 'rgb(147, 172, 211)'; // 灰色
    }
    // ↓ 未平仓, 白色 
    return '#fff';
});

// ↓ 图标名 
const sIcon = computed(() => {
    if (
        props.state === oWavesContractStatus.profit
        || props.state === oWavesContractStatus.cashed
    ){
        return 'icon-checkmark'; // ✔  // icon-check-small 
    }else if (
        props.state === oWavesContractStatus.loss
        || props.state === oWavesContractStatus.busted
    ){
        return 'icon-close'; // ✘ 
    }
    // ↓ 未平仓 
    return 'circle-narrow'; // ○ 
});

</script>

<style scoped lang="scss">
.contract-state{
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap; 
}

</style>
